import { useProductReportControllerGetPurchaseFunnel } from "@/api/types/main";
import { FunnelHistoryDTO } from "@/api/types/main/schemas";
import { useCommersCardProps } from "@/hooks/useCommersCardProps";
import { TableIds } from "@/store/tables";
import { TransformCardData } from "./commers.card.rating";
import { useCommersCardColumns } from "@/hooks/useCommersCardColumns";
import { LoadingSpinner } from "@/components/custom-ui/loading.spinner";
import { ConversionCardTable } from "@/components/tables/commers/cards/conversion/coversion.card.table";
import { FunnelChart } from "@/components/charts/funnel.chart";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { format } from "date-fns";
import { ru } from "date-fns/locale";
import { formatNumber } from "@/lib/utils";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";

const READABLE_CONVERSION_CARD_LABELS: Record<keyof FunnelHistoryDTO, string> = {
  basketOrder: "Корзина → заказ",
  basketOrderPercent: "Корзина → заказ, %",
  cardBasket: "Карточка → корзина",
  cardBasketPercent: "Карточка → корзина, %",
  showCard: "Показ → Карточка",
  showCardPercent: "Показ → Карточка, %",
  showLook: "Общее кол-во показов",
  tacos: "TACOS",
  cr: "CR",
};
export const CommersCardConversions = () => {
  const { productId, dateRange, isSidebarVisible, savedSettings } = useCommersCardProps({
    TableId: TableIds.Commers_ConversionCard,
  });
  const { data, isLoading, isError, error } = useProductReportControllerGetPurchaseFunnel(
    productId,
    {
      periodEnd: format(dateRange.to, "yyyy-MM-dd"),
      periodStart: format(dateRange.from, "yyyy-MM-dd"),
    },
    {
      query: {
        queryKey: ["card", "conversion", "history", dateRange.from, dateRange.to],
        select: (data) => {
          const keys = Object.keys(data.history) as (keyof FunnelHistoryDTO)[];
          const dataChart = [
            {
              key: "showLook",
              value: data.stat.showLook,
              fill: "var(--color-showLook)",
            },
            {
              key: "showCard",
              value: data.stat.showCard,
              fill: "var(--color-showCard)",
            },
            {
              key: "cardBasket",
              value: data.stat.cardBasket,
              fill: "var(--color-cardBasket)",
            },
            {
              key: "basketOrder",
              value: data.stat.basketOrder,
              fill: "var(--color-basketOrder)",
            },
          ];

          const dataTable = keys.map(
            (field): TransformCardData => ({
              label: READABLE_CONVERSION_CARD_LABELS[field] || "Значение не добавлено",
              data: data.history[field],
            })
          );
          return { dataTable, dataChart };
        },
      },
    }
  );

  const columns = useCommersCardColumns({ dateRange: dateRange });
  if (isError) return <div>{error?.message}</div>;
  if (isLoading) return <LoadingSpinner />;
  return (
    <div className="flex flex-col h-full max-h-[calc(100vh-180px)]">
      <ScrollArea className="flex-1 ">
        {data && (
          <>
            <ConversionCardTable
              data={data.dataTable}
              columns={columns}
              isSidebarVisible={isSidebarVisible}
              savedSettings={savedSettings}
              tableId={TableIds.Commers_ConversionCard}
            />
            <Card>
              <CardHeader>
                <CardTitle>Воронка продаж</CardTitle>
                <CardDescription>
                  С {format(dateRange.from!, "dd MMMM", { locale: ru })} по{" "}
                  {format(dateRange.to!, "dd MMMM", { locale: ru })}
                </CardDescription>
              </CardHeader>
              <CardContent>
                {/* TODO: Переделать на нормальный маппинг, костыль */}
                <div className="grid grid-cols-4 mb-2">
                  <div className="text-left">
                    <div className="text-xl">Показы</div>
                    <div className="text-3xl font-semibold">
                      {formatNumber(data.dataChart[0].value) || "Нет данных"}
                    </div>
                  </div>
                  <div className="text-left">
                    <div className="text-xl">Карточка</div>
                    <div className="text-3xl font-semibold">
                      {formatNumber(data.dataChart[1].value) || "Нет данных"}
                    </div>
                  </div>
                  <div className="text-left">
                    <div className="text-xl">Корзина</div>
                    <div className="text-3xl font-semibold">
                      {formatNumber(data.dataChart[2].value) || "Нет данных"}
                    </div>
                  </div>
                  <div className="text-left">
                    <div className="text-xl">Заказ</div>
                    <div className="text-3xl font-semibold">
                      {formatNumber(data.dataChart[3].value) || "Нет данных"}
                    </div>
                  </div>
                </div>
                <FunnelChart data={data.dataChart} />
              </CardContent>
            </Card>
          </>
        )}
        <ScrollBar orientation="vertical" />
        <ScrollBar orientation="horizontal" />
      </ScrollArea>
    </div>
  );
};
